const $ulm = $('#ulm');
const metaVonBisMode = ($('#ulm.metaVonBisMode').length) ? true : false;
let ulm_locations = [];
let globalUlmListCount = 0;

// console.log('-1');

$(document).ready(function() {
    // console.log('0');

    if ($ulm.length) {
        // console.log('1');
        ulm_loadLocations();
        // Nicht auf die Orte-Liste warten (~750 KB, nur fürs Autocomplete) – setValues liest nur den Hash
        ulm_setValues();

        // ULM-81: Personalisierung für TOURDATA Objekte
        ulm_injectTdObjectWrapper();

        const today = new Date();
        let d = (today.getDate() < 10) ? '0' + today.getDate() : today.getDate();
        const mFix = today.getMonth() + 1;
        let m = (mFix < 10) ? '0' + mFix : mFix;
        $ulm.find('.form-control[name="date"]').prop({
            'value': today.getFullYear() + '-' + m + '-' + d,
            'min': today.getFullYear() + '-' + m + '-' + d
        }).change(function() {
            ulm_loadStep1();

            if (metaVonBisMode) {
                let thisDateObj = ulm_dateString2dateObject($(this).val());
                ulm_bisDateMin(thisDateObj);
                ulm_bisDateClearIf2Early(thisDateObj);
            }

        });

        if (metaVonBisMode) {
            ulm_bisDateMin(today);
            $ulm.find('.form-control[name="dateBis"]')
                .change(function() {
                    ulm_loadStep1();
                });
        }

        $ulm.find('.form-control').focus(function() {
            $(this).closest('.input-group').addClass('focus');
        }).focusout(function() {
            $(this).closest('.input-group').removeClass('focus');
        });

        // Browser Vor/Zurück Action
        window.onpopstate = function(event) {
            if (event.state) {
                ulm_setValues(event.state);
                ulm_loadStep1('DoNotUpdateHistory');
            }
        };

        // Sprungmarken
        $ulm.on('click', '.ankernavi a', function(e) {
            const id = $(this).prop('href').split('#');
            e.preventDefault();
            document.getElementById(id[1]).scrollIntoView();
            trackEvent('Global', 'ULM-Kategorie', $(this).text(), 1);
        });

        // Live View Trigger
        /*
        $ulm.on('click', '.ulm_liveViewTrigger', function(e) {
            const $form = $(this);
            $form.find('input[name="listViewItems"]').remove();
            e.preventDefault();

            let listViewItems = [];
            $.each($ulm.find('.entry.liveView'), function(i, v) {
                let $item = $(this);
                let lVItem = {
                    type: $item.data('type'),
                    id: $item.data('id'),
                    title: $item.find('h3 span').text().trim(),
                    titleLength: $item.find('h3 span').text().trim().length,
                    entf: $($item.find('.content .infos .entf span')[2]).text().trim(),
                    coords: {
                        lat: $item.data('lat'),
                        lon: $item.data('lng')
                    },
                    picUrl: $item.find('.img').css('background-image').replace('url("', '').replace('")', ''),
                    url: $item.find('a').prop('href')
                }
                // console.log($(this).find('img'));
                listViewItems.push(lVItem);
            });
            console.log('Live View Trigger', listViewItems);

            let $listViewItems = $('<input />').prop({ 'name': 'listViewItems', 'type': 'hidden' }).val(JSON.stringify(listViewItems));
            $listViewItems.appendTo($form);

            // $('<input />').prop({ 'name': 'no_cache', 'type': 'hidden' }).val('1').appendTo($form);

            $form.submit();

        });
        */

    }


});

const ulm_setValues = function(historyObj) {

    let ulm_hashObj = {};
    if (window.location.hash) { // Hash Parameter vorhanden
        ulm_hashObj = generateObjectFromHash(window.location.hash); // Function aus tdLists.js
    } else if (historyObj) { // History API Obj übergeben
        ulm_hashObj = historyObj;
    }

    if (ulm_hashObj.date) {
        const givenDate = new Date(ulm_hashObj.date);
        const minDate = new Date($ulm.find('.form-control[name="date"]').prop('min'));
        if (givenDate <= minDate) {
            $ulm.find('.form-control[name="date"]').val($ulm.find('.form-control[name="date"]').prop('min'));
            if (metaVonBisMode) {
                let thisDateObj = ulm_dateString2dateObject($ulm.find('.form-control[name="date"]').prop('min'));
                ulm_bisDateMin(thisDateObj);
                ulm_bisDateClearIf2Early(thisDateObj);
            }
        } else {
            $ulm.find('.form-control[name="date"]').val(ulm_hashObj.date);
            if (metaVonBisMode) {
                ulm_bisDateMin(givenDate);
                ulm_bisDateClearIf2Early(givenDate);
            }
        }
    }

    if (metaVonBisMode) {
        if (ulm_hashObj.dateBis) {
            const givenBisDate = new Date(ulm_hashObj.dateBis);
            const minBisDate = new Date($ulm.find('.form-control[name="dateBis"]').prop('min'));
            if (givenBisDate <= minBisDate) {
                $ulm.find('.form-control[name="dateBis"]').val($ulm.find('.form-control[name="dateBis"]').prop('min'));
            } else {
                $ulm.find('.form-control[name="dateBis"]').val(ulm_hashObj.dateBis);
            }
        }
    }

    if (!ulm_hashObj.loctype) {
        ulm.loctype = 'default';
    }

    // tdobject => über den Hash kann auch ein TOURDATA Objekt mittels tdobject=Hotel:ID übergeben werden. Es muss der Objekttyp der META übergeben werden
    if (ulm_hashObj.tdobject) {
        ulm.tdobject = ulm_hashObj.tdobject;
    }

    if (ulm_hashObj.located && ulm_hashObj.located !== 'true') {
        $ulm.find('.form-control[name="standort"]').data({
            lat: ulm_hashObj.lat,
            lon: ulm_hashObj.lon,
            located: ulm_hashObj.located,
            loctype: ulm_hashObj.loctype
        }).val((ulm_hashObj.loctype === 'given') ? $ulm.find('#standort').data('naehe') + ', ' + decodeURIComponent(ulm_hashObj.located) : decodeURIComponent(ulm_hashObj.located));
        if (ulm_hashObj.loctype === 'given') {
            $ulm.find('.form-control[name="standort"]')
                .closest('.input-group').find('.input-group-addon')
                .empty()
                .html('<span class="i fas fa-search-location fa-fw"></span>');
        } else {
            $ulm.find('.form-control[name="standort"]')
                .closest('.input-group').find('.input-group-addon')
                .empty()
                .html('<span class="i fas fa-map-marker-alt fa-fw"></span>');
        }
        ulm_loadStep1();
    } else {
        ulm_geoLocator();
    }

};

const ulm_loadStep1 = function(updateHistory = true) {
    const $step1 = $ulm.find('.ajax-step1');
    const ulmIds = $ulm.data('ulm-ids');
    const lang = $ulm.data('lang');
    const sysLanguageUid = $ulm.data('syslanguageuid');

    if (ulmIds) {
        $.ajax({
            method: 'POST',
            url: "/index.php?id=" + rootPage + "&step=1&type=1930&L=" + sysLanguageUid,
            data: {
                ulmIds: ulmIds,
                lang: lang,
                sysLanguageUid: sysLanguageUid,
                date: $ulm.find('.form-control[name="date"]').val(),
                metaVonBisMode: metaVonBisMode
            },
            beforeSend: function(xhr, settings) {

                globalUlmListCount = 0;
                _ttgMaps.f.ulmMap.resetMap();

                // EVENT TRACKING
                trackEvent('Global', 'ULM-Datum', $ulm.find('.form-control[name="date"]').val(), 1);
                if ($ulm.find('.form-control[name="standort"]').data('located') === 'true') {
                    trackEvent('Global', 'ULM-Geodaten', 'lat: ' + $ulm.find('.form-control[name="standort"]').data('lat') + ', lon: ' + $ulm.find('.form-control[name="standort"]').data('lon'), 1);
                } else {
                    if ($ulm.find('.form-control[name="standort"]').data('loctype') === 'given') {
                        trackEvent('Global', 'ULM-Objekt', $ulm.find('.form-control[name="standort"]').data('located'), 1);
                    } else {
                        if ($ulm.find('.form-control[name="standort"]').data('located') !== 'false') {
                            trackEvent('Global', 'ULM-Ort', $ulm.find('.form-control[name="standort"]').data('located'), 1);
                        } else {
                            trackEvent('Global', 'ULM-Geodaten', 'keine Standortfreigabe', 1);
                        }
                    }
                }

                $step1.empty();
                ulm_loader($step1, 'add');
            },
            success: function(response, status, xhr) {
                $step1.html(response);
            },
            complete: function(xhr, status) {
                if (updateHistory === true) {
                    ulm_historyAPI();
                }
                ulm_createAnkerSlick($ulm.find('.ankernavi ul'));
                $.each($step1.find('.list'), function(i, v) {
                    ulm_loadStep2($(this), 'init', $step1.find('.list').length);
                });
                ulm_loader($step1, 'remove');
                $step1.attr('aria-busy', false);
            }
        });
    }

};

const ulm_loadStep2 = function($list, mode = 'init', listCount = 1) {
    const $step2 = (mode === 'init') ? $list.find('.ajax-step2') : $list;
    const lang = $ulm.data('lang');
    const sysLanguageUid = $ulm.data('syslanguageuid');
    const $useListPageId4DetailURL = $ulm.data('ulmuselistpageid4detailurl');
    const $pageId = $ulm.data('ulm-page-id');

    let location = false;
    if ($ulm.find('.form-control[name="standort"]').data('lat') && $ulm.find('.form-control[name="standort"]').data('lon')) {
        location = {
            lat: $ulm.find('.form-control[name="standort"]').data('lat'),
            lon: $ulm.find('.form-control[name="standort"]').data('lon'),
            located: $ulm.find('.form-control[name="standort"]').data('located'),
            loctype: $ulm.find('.form-control[name="standort"]').data('loctype')
        };
    }

    let metaVonBisModeObj = false;
    if (metaVonBisMode) {
        metaVonBisModeObj = {
            dateVon: $ulm.find('.form-control[name="date"]').val(),
            dateBis: $ulm.find('.form-control[name="dateBis"]').val()
        };
    }

    // Offset/Limit dieses Requests festhalten: das Limit haengt vom Freeda-Filter
    // ab (siehe ulm_loadLimit), der Offset darf deshalb nicht mit einem festen
    // Wert weitergezaehlt werden, sonst entstehen Luecken beim Umschalten.
    const requestOffset = parseInt($step2.data('offset')) || 0;
    const requestLimit = ulm_loadLimit();

    const resp = $.ajax({
        method: 'POST',
        url: "/index.php?id=" + rootPage + "&step=2&type=1940&L=" + sysLanguageUid,
        data: {
            lang: lang,
            sysLanguageUid: sysLanguageUid,
            location: location,
            date: $ulm.find('.form-control[name="date"]').val(),
            listPageId: $step2.data('listpageid'),
            offset: requestOffset,
            limit: requestLimit,
            metaVonBisMode: metaVonBisModeObj,
            ulmMaps: $('#ulmMaps').length,
            useListPageId4DetailURL: $useListPageId4DetailURL,
            pageId: $pageId,
        },
        beforeSend: function(xhr, settings) {
            if (mode === 'init') {
                ulm_extraLoader($step2, 'add');
            } else {
                ulm_loader($step2, 'add');
            }

            if (ttgMaps.length > 0) {
                _ttgMaps.f.ulmMap.addLocation(ttgMaps[0], location);
            }

            /*
            if (location.located !== 'true') {
                $('.ulm_liveViewTrigger, .ulm_liveView').remove();
            }
            */
        },
        success: function(response, status, xhr) {
            // Offset um das tatsaechlich angeforderte Limit weiterzaehlen
            $step2.data('offset', requestOffset + requestLimit);

            if (mode === 'init') {
                $step2.append(response);
            } else {
                // slickAdd() setzt $slidesCache aus den EINGEHAENGTEN Slides neu.
                // Bei aktivem Freeda-Filter sind die gefilterten Objekte detacht,
                // sie wuerden dabei dauerhaft verloren gehen -> unfiltern,
                // hinzufuegen, wieder filtern.
                const wasFreedaFiltered = ulm_freedaFilterIsActive();
                if (wasFreedaFiltered) {
                    ulm_slickUnfilterFreeda($step2);
                }

                // Vor/Nach-Vergleich der Slide-Anzahl: bringt die Antwort keinen
                // einzigen Slide mehr, ist die Quelle erschoepft -> kein weiteres
                // Nachladen mehr anstossen. Bewusst nicht "< limit", weil eine volle
                // Seite je nach Objekttyp weniger als limit .entry rendern kann.
                const countBefore = $step2.slick('getSlick').slideCount;
                $step2.slick('slickAdd', response);
                if ($step2.slick('getSlick').slideCount === countBefore) {
                    $step2.data('ulm-exhausted', true);
                }

                if (wasFreedaFiltered) {
                    ulm_slickFilterFreeda($step2);
                }
                // _ttgMaps.f.ulmMap.reDrawLists();
            }
        },
        complete: function(xhr, status) {
            if (mode === 'init') {
                ulm_createListSlick($step2);
                $('#ulmMaps').show();
                _ttgMaps.f.ulmMap.addListBtn($list);
            }

            ulmCopyrightFixer();
            ulmRenderOpeningInfos();

            if (mode === 'init') {
                ulm_extraLoader($step2, 'remove');
            } else {
                ulm_loader($step2, 'remove');
                $step2.data('ulm-loading', false);
            }
            $step2.attr('aria-busy', false);

            // Achtung: bei aktivem Freeda-Filter sind die gefilterten .entry aus dem
            // DOM detacht. Die Liste sieht dann leer aus, darf aber NICHT entfernt
            // werden - sonst gehen die ausgefilterten Objekte unwiederbringlich verloren.
            if (!ulm_freedaFilterIsActive() && !$step2.find('.entry').length) {
                const ulmAnkerId = $step2.closest('.list').prop('id').replace('listItem', 'ankerItem');
                $step2.closest('.list').remove();
                $ulm.find('#' + ulmAnkerId).remove();
            }

            // Filter war beim Neuladen (Step1/Step2) schon aktiv -> erst jetzt anwenden,
            // damit die regulaere Leer-Pruefung oben auf den ungefilterten Stand schaut.
            if (ulm_freedaFilterIsActive()) {
                if (mode === 'init') {
                    ulm_freedaFilterList($step2);
                } else {
                    // Beim Nachladen wurde bereits in success() gefiltert,
                    // hier nur den Leer-Status nachziehen
                    $step2.closest('.list').toggleClass('freeda-filter-empty', !$step2.find('.entry').length);
                }
                ulm_freedaFilterAnkernavi(true);

                // Ergebniszaehler und Live-Region des Filter-Buttons nachziehen
                // (Logik liegt in tdLists.js).
                if (mode === 'add' && typeof window.freedaFilterUpdateStatus === 'function') {
                    window.freedaFilterUpdateStatus($ulm);
                }

                // Nachlade-Kette fortsetzen, solange der Filter zu wenig sichtbare
                // Slides uebrig laesst.
                ulm_freedaAutoLoad($step2);
            }

            // Tooltips für Akutmeldungen ausgeben
            $step2.find('.js-tooltip').each(function() {
                // Call the function with this as the current tooltip
                accessibleSimpleTooltipAria.apply(this);
            });

            globalUlmListCount++;
            if ($('#ulmMapOptions').length > 0 && (mode === "add" || globalUlmListCount === listCount)) {
                _ttgMaps.f.ulmMap.reDrawLists();
            }

            /*
            if (location.located === 'true') {
                ulm_checkLiveView($step2);
            }
            */
        }
    });

};

const ulmCopyrightFixer = function() {

    // beim Klick auf das Copyright Icon soll mobil dann die Pfeil Navi ausgeblendet werden
    if ($(window).width() < 1170) {
        // Pfeil Navi ausblenden
        $('#ulm .slick-list').on('click', '.ttgCopyrightIcon', function() {
            const slickObj = $(this).closest('.slick-slider');
            slickObj.find('button.slick-arrow').hide();

            // das Icon in der oberen linken Ecke soll nicht mehr angezeigt werden -> könnte sich überlappen
            const iconLeftEdge = $(this).closest('.entry');
            iconLeftEdge.find('.ulmMaps_listTrigger_entry').fadeOut('fast');
        });
        // beim Klick auf den Close Button soll die Pfeil Navi wieder eingeblendet werden
        $('#ulm .slick-list').on('click', '.ttgCopyrightText button.ttgCopyrightTextBtn span.fa-times', function() {
            const slickObj = $(this).closest('.slick-slider');

            const blockCount = slickObj.find('.ttgCopyrightText').filter(function() {
                return $(this).css('display') === 'block';
            }).length;

            // nur wenn kein Copyright mehr ausgegeben wird, dann Pfeil Navi wieder einblenden
            if (blockCount === 1) {
                slickObj.find('button.slick-arrow').show();
            }

            // das Icon in der oberen linken Ecke soll wieder angezeigt werden
            const iconLeftEdge = $(this).closest('.entry');
            iconLeftEdge.find('.ulmMaps_listTrigger_entry').fadeIn('fast');
        });
    }

};

const ulm_loader = function($location, addRemove) {

    if (addRemove === 'add') {
        const $loader = $('<div />').addClass('loader').html('<div class="lds-ripple"><div></div><div></div></div>');
        $location.prepend($loader);
    } else {
        $location.find('.loader').first().remove();
    }

};

const ulm_extraLoader = function($location, addRemove) {

    if (addRemove === 'add') {
        const $loader = $('<div />').addClass('extraLoader').html('<div class="lds-facebook"><div></div><div></div><div></div></div><div>' + $location.data('loading') + '</div>');
        $location.prepend($loader);
    } else {
        $location.find('.extraLoader').first().remove();
    }

};

const ulm_slidesToShow = function() {

    const wWidth = $(window).width();
    let slides2show = 3;
    if (wWidth < 1200 && wWidth > 769) {
        slides2show = 2;
    } else if (wWidth < 768) {
        slides2show = 1;
    }
    return slides2show;

};

/* ===== Nachladen der Carousel-Objekte ===== */

// Seitengroesse des step2Action (MetaQuery limit)
const ULM_LOAD_LIMIT = 10;
// Groessere Seite bei aktivem Freeda-Filter: von 10 Objekten bleiben oft nur
// 0-1 uebrig, mit der Standard-Seitengroesse braeuchte es sehr viele Requests.
// Muss <= dem serverseitigen Maximum in UlmController::step2Action bleiben.
const ULM_LOAD_LIMIT_FREEDA = 50;
// So viele Slides muessen hinter der aktuellen Position noch uebrig sein,
// sonst wird nachgeladen.
const ULM_LOAD_THRESHOLD = 3;
// Sicherheitsnetz: maximal so viele Nachladungen ohne Nutzerinteraktion.
// Mit ULM_LOAD_LIMIT_FREEDA sind das bis zu 200 durchsuchte Objekte pro Liste.
const ULM_AUTOLOAD_MAX = 4;

const ulm_loadLimit = function() {
    return ulm_freedaFilterIsActive() ? ULM_LOAD_LIMIT_FREEDA : ULM_LOAD_LIMIT;
};

// Anzahl der Slides hinter der aktuellen Position. null, wenn (noch) kein slick.
const ulm_slidesLeft = function($step2) {
    if (!$step2.hasClass('slick-initialized')) {
        return null;
    }
    const slick = $step2.slick('getSlick');
    // slidesToShow aus der slick-Instanz: danach richtet sich auch updateArrows(),
    // d.h. ab slideCount <= slidesToShow ist gar keine Navigation mehr moeglich.
    const slides2show = slick.options.slidesToShow || ulm_slidesToShow();

    return slick.slideCount - slides2show - slick.currentSlide;
};

const ulm_loadMore = function($step2) {
    if ($step2.data('ulm-loading') || $step2.data('ulm-exhausted')) {
        return;
    }
    $step2.data('ulm-loading', true);
    ulm_loadStep2($step2, 'add');
};

const ulm_checkLoadMore = function($step2) {
    const slidesLeft = ulm_slidesLeft($step2);
    if (slidesLeft !== null && slidesLeft <= ULM_LOAD_THRESHOLD) {
        ulm_loadMore($step2);
    }
};

/* ===== DataViewer: Freeda-Filter im ULM =====
   Der Umschalt-Button und die Zaehler-Logik liegen in tdLists.js
   (freedaFilterApply), hier nur das slick-spezifische Umbauen der Carousels. */

const ulm_freedaFilterIsActive = function() {
    return $ulm.hasClass('freeda-filter-active');
};

// Achtung: filterSlides() setzt $slidesCache auf die aktuell EINGEHAENGTEN Slides,
// unfilterSlides() haengt $slidesCache wieder ein und laesst den Cache stehen.
const ulm_slickFilterFreeda = function($slider) {
    if (!$slider.hasClass('slick-initialized')) {
        return;
    }
    if ($slider.data('ulm-freeda-filtered')) {
        $slider.slick('slickUnfilter');
    }
    $slider.slick('slickFilter', '.not-freeda');
    $slider.data('ulm-freeda-filtered', true);
};

const ulm_slickUnfilterFreeda = function($slider) {
    if ($slider.hasClass('slick-initialized') && $slider.data('ulm-freeda-filtered')) {
        $slider.slick('slickUnfilter');
        $slider.data('ulm-freeda-filtered', false);
    }
};


const ulm_freedaFilterList = function($step2) {
    ulm_slickFilterFreeda($step2);
    // Liste ohne Treffer inkl. Ueberschrift ausblenden - NIE entfernen,
    // der Filter muss vollstaendig umkehrbar bleiben.
    $step2.closest('.list').toggleClass('freeda-filter-empty', !$step2.find('.entry').length);
};

// Auto-Nachladen bei aktivem Freeda-Filter.
const ulm_freedaAutoLoad = function($step2) {
    if (!ulm_freedaFilterIsActive() || $step2.data('ulm-exhausted')) {
        return;
    }

    const runs = parseInt($step2.data('ulm-autoload') || 0);
    if (runs >= ULM_AUTOLOAD_MAX) {
        return;
    }

    const slidesLeft = ulm_slidesLeft($step2);
    if (slidesLeft === null || slidesLeft > ULM_LOAD_THRESHOLD) {
        return;
    }

    $step2.data('ulm-autoload', runs + 1);
    ulm_loadMore($step2);
};

// Die Ankernavi ist selbst ein slick-Slider mit variableWidth -> display:none
// wuerde getLeft() zerstoeren (offsetLeft = 0). Deshalb ebenfalls slickFilter.
// Unkritisch, weil auf der Ankernavi nie slickAdd laeuft.
const ulm_freedaFilterAnkernavi = function(active) {
    const $ankernavi = $ulm.find('.ankernavi ul');
    if (!$ankernavi.hasClass('slick-initialized')) {
        return;
    }

    $ankernavi.slick('slickUnfilter');

    $.each($ulm.find('.lists .list'), function() {
        const ankerId = $(this).prop('id').replace('listItem', 'ankerItem');
        $ankernavi.find('#' + ankerId).toggleClass('freeda-filter-empty', $(this).hasClass('freeda-filter-empty'));
    });

    if (active) {
        $ankernavi.slick('slickFilter', 'li:not(.freeda-filter-empty)');
    }

    // slick setzt aria-hidden auf alle Slides, hier unerwuenscht (wie in ulm_createAnkerSlick)
    $ankernavi.find('.slick-slide').removeAttr('aria-hidden');
};

// Einstiegspunkt fuer den Button in tdLists.js
window.ulm_freedaFilterRelayout = function(active) {
    if (!$ulm.length) {
        return;
    }

    $.each($ulm.find('.lists .list'), function() {
        const $list = $(this);
        const $step2 = $list.find('.ajax-step2');

        // Umschalten ist eine Nutzerinteraktion -> Auto-Nachlade-Zaehler zuruecksetzen
        $step2.data('ulm-autoload', 0);

        if (active) {
            ulm_freedaFilterList($step2);
        } else {
            ulm_slickUnfilterFreeda($step2);
            $list.removeClass('freeda-filter-empty');
        }
    });

    ulm_freedaFilterAnkernavi(active);

    // Erst nach dem Filtern aller Listen nachladen, damit die Ankernavi den
    // Leer-Status einmal komplett bekommt.
    if (active) {
        $.each($ulm.find('.lists .list .ajax-step2'), function() {
            ulm_freedaAutoLoad($(this));
        });
    }
};

const ulm_createAnkerSlick = function($ankernavi) {

    $ankernavi.on('init', function(event, slick, currentSlide) {
        $ankernavi.find('.slick-slide').removeAttr('aria-hidden');
    });

    $ankernavi.slick({
        accessibility: false,
        variableWidth: true,
        swipeToSlide: true,
        infinite: false,
        arrows: false
    }).on('afterChange', function(event, slick, currentSlide) {
        $ankernavi.find('.slick-slide').removeAttr('aria-hidden');
    });

};

const ulm_createListSlick = function($list) {
    var next = $list.data('next');
    var prev = $list.data('prev');

    // Defensiv abmelden, damit die Handler bei einem erneuten Aufbau nicht doppelt haengen
    $list.off('init reInit afterChange');

    $list.slick({
        accessibility: false,
        slidesToShow: ulm_slidesToShow(),
        variableWidth: true,
        swipeToSlide: true,
        infinite: false,
        slide: '.entry',
        prevArrow: '<button class="slick-prev" type="button"><span class="fas fa-arrow-left" aria-hidden="true"></span><span class="sr-only">' + prev + '</span></button>',
        nextArrow: '<button class="slick-next" type="button"><span class="fas fa-arrow-right" aria-hidden="true"></span><span class="sr-only">' + next + '</span></button>'
    }).on('afterChange', function(event, slick, currentSlide) {

        // Nutzer navigiert selbst -> Auto-Nachlade-Zaehler zuruecksetzen
        $list.data('ulm-autoload', 0);
        ulm_checkLoadMore($list);
    });

};

const ulm_historyAPI = function() {

    let params = {
        date: $ulm.find('.form-control[name="date"]').val()
    };

    if (metaVonBisMode) {
        params.dateBis = $ulm.find('.form-control[name="dateBis"]').val();
    }

    let locationTitle = '';

    if ($ulm.find('.form-control[name="standort"]').data('lat') && $ulm.find('.form-control[name="standort"]').data('lon')) {
        params.lat = $ulm.find('.form-control[name="standort"]').data('lat');
        params.lon = $ulm.find('.form-control[name="standort"]').data('lon');
        params.located = $ulm.find('.form-control[name="standort"]').data('located');
        params.loctype = $ulm.find('.form-control[name="standort"]').data('loctype');
        let locationTitle = ' (Location: ' + params.label + ' | ' + params.lat + ',' + params.lon + ')';
    }

    if ($('.ulm-tdobject-wrapper').data('tdobject')) {
        params.tdobject = $('.ulm-tdobject-wrapper').data('tdobject');
    }

    const title = 'ULM: ' + params.date + locationTitle;
    const hash = generateHashFromObject(params); // Function aus tdLists.js
    history.pushState(params, title, window.location.pathname + window.location.search + hash);

};

const ulm_geoLocator = function() {

    navigator.permissions.query({ name: 'geolocation' }).then(function(status) {
        if (status.state !== 'granted') {
            $('<div />').addClass('geoLocatorActive').html('<div><span class="i fas fa-search-location"></span>' + $ulm.data('geolocator') + '</div>').appendTo('body');
        }
    });

    navigator.geolocation.getCurrentPosition(
        function(position) {

            $ulm.find('.form-control[name="standort"]').data({
                lat: position.coords.latitude,
                lon: position.coords.longitude,
                located: 'true',
                loctype: 'default'
            })
                .val($ulm.find('#standort').data('naehe') + ', ' + $ulm.find('#standort').data('standort'))
                .closest('.input-group').find('.input-group-addon')
                .empty()
                .html('<span class="i fas fa-street-view fa-fw"></span>');
            ulm_loadStep1();
            $('.geoLocatorActive').remove();

        },
        function(error) {

            console.log(error);
            $('<div />').addClass('geoLocatorErrorMsg').html(
                $ulm.find('.form-control[name="standort"]').data('geolocatorerrormsg')
            ).appendTo(
                $ulm.find('.form-control[name="standort"]').closest('.input-group').addClass('errorMsg')
            );
            $ulm.find('.form-control[name="standort"]').data({
                lat: '',
                lon: '',
                located: 'false',
                loctype: 'default'
            });
            ulm_loadStep1();
            $('.geoLocatorActive').remove();

        }
    );

};

const ulm_injectTdObjectWrapper = function() {
    const ulm_hashObj = generateObjectFromHash(window.location.hash); // Function aus tdLists.js
    if (ulm_hashObj.tdobject) {
        const tdObjectTmp = ulm_hashObj.tdobject;
        let tdObject = [];
        if (tdObjectTmp !== 'default') {
            if (tdObjectTmp.indexOf(":") > -1) {
                tdObject = tdObjectTmp.split(':');
                let tdContent = '\
                    <div class="container ttgNCEContainer grid-1-0">\
                        <div class="row ttgRbRow">\
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">\
                                <div class="ttgNCEWrapper ttgNCEText ttgNCECenterText ulm-tdobject-wrapper" data-tdobject="'+ tdObject[0] + ':' + tdObject[1] + '"></div>\
                            </div>\
                        </div>\
                    </div>';
                let rbcWrapper = $ulm.closest('#ttgRbContentWrapper');
                rbcWrapper.find('.container.ttgNCEContainer').addClass('ulm-hide-nce');
                rbcWrapper.prepend(tdContent);
                ulm_loadTdObject(tdObject, rbcWrapper);
            }
        }
    }
};

// Achtung: derzeit wird sowohl der Objekt Titel, als auch "Herzlich Willkommnen" nur auf deutsch ausgegeben. Müsste noch für Englisch angepasst werden.
const ulm_loadTdObject = function(tdObject, rbcWrapper) {
    var exp = ($('#ulm [name="standort"]').data('ortederexperience') == '1') ? $('#ulm [name="standort"]').data('exp') : 'webarchitektur-meta';
    $.ajax({
        method: 'POST',
        url: window.location.protocol + "//" + window.location.host + "/?type=2090",
        data: {
            experience: exp,
            template: "ET2014A.json",
            type: tdObject[0],
            q: "sourceid:" + tdObject[1],
            limit: 1
        },
        dataType: 'jsonp',
        beforeSend: function(xhr, settings) {},
        success: function(response, status, xhr) {
            if (response && response.items.length) {

                // sofern bereits ein ttgNCEContainer innerhalb des tdObjectWrapper vorhanden ist, wird dieser entfernt und durch den neuen ersetzt
                // lt. Ticket soll der Upperguide Text doch nicht enfernt werden
                // rbcWrapper.find('.ulm-hide-nce').remove();

                let image = '';
                let images = response.items[0].media_objects;
                images.filter(function(e) {
                    if (e.rel === 'logo') {
                        image += '\
                            <div class="row">\
                                <div class="col-xs-1 col-sm-2 col-md-3 col-lg-3"></div>\
                                <div class="col-xs-10 col-sm-8 col-md-6 col-lg-6">\
                                    <img class="img-fluid text-center" src="' + e.url + '" alt="' + e.value + '" />\
                                </div>\
                                <div class="col-xs-1 col-sm-2 col-md-3 col-lg-3"></div>\
                            </div>';
                    }
                });

                let welcome = "Herzlich willkommen!"
                if ($ulm.data('lang') === 'en') {
                    welcome = "A warm welcome!"
                }
                let tdContent = '\
                    <h2 class="mt-3">' + response.items[0].title + '</h2>\
                    <h3>'+ welcome + '</h3>';
                $('.ulm-tdobject-wrapper').html(image + tdContent);
            }
        },
        complete: function(xhr, status) {
        }
    });
};

const ulm_loadLocations = function() {

    let locations = [{
        label: $ulm.find('#standort').data('naehe'),
        desc: $ulm.find('#standort').data('standort'),
        value: {
            geoLocator: true
        },
        icon: "fas fa-street-view"
    }];

    const ulm_hashObj = generateObjectFromHash(window.location.hash); // Function aus tdLists.js
    if (ulm_hashObj.loctype === 'given') {
        locations.push({
            label: $ulm.find('#standort').data('naehe'),
            desc: ulm_hashObj.located,
            value: {
                lat: ulm_hashObj.lat,
                lon: ulm_hashObj.lon
            },
            icon: "fas fa-search-location"
        });
    }

    var exp = ($('#ulm [name="standort"]').data('ortederexperience') == '1') ? $('#ulm [name="standort"]').data('exp') : 'webarchitektur-meta';

    $.ajax({
        method: 'POST',
        url: window.location.protocol + "//" + window.location.host + "/?type=2090",
        data: {
            experience: exp,
            template: "ET2014A_LIGHT.json",
            type: "City",
            facets: false,
            sort: "title asc"
        },
        dataType: 'jsonp',
        beforeSend: function(xhr, settings) {},
        success: function(response, status, xhr) {
            if (response && response.items.length) {
                $.each(response.items, function(i, v) {
                    let location = {
                        label: v.city,
                        desc: v.district,
                        value: {
                            lat: v.geo.main.latitude,
                            lon: v.geo.main.longitude,
                        },
                        icon: (v.type === 'City') ? 'fas fa-map-marker-alt' : 'fas fa-bullseye',
                    };
                    locations.push(location);
                });
            }
        },
        complete: function(xhr, status) {
            ulm_setupAutoComplete(locations);
        }
    });

};

const ulm_setupAutoComplete = function(locations) {

    $ulm.find('.form-control[name="standort"]').autocomplete({
        source: locations,
        minLength: 0,
        focus: function(e, ui) {
            let value = ui.item.label;
            if (ui.item.desc && ui.item.desc != "" && !ui.item.value.geoLocator) {
                value += ', ' + ui.item.desc;
            }
            $(this)
                .val(value)
                .closest('.input-group').find('.input-group-addon')
                .empty()
                .html('<span class="i ' + ui.item.icon + ' fa-fw"></span>');

            return false;
        },
        select: function(e, ui) {
            $ulm.find('.geoLocatorErrorMsg').remove();
            $ulm.find('.errorMsg').removeClass('errorMsg');

            let value = ui.item.label;
            if (ui.item.desc && ui.item.desc != "" && !ui.item.value.geoLocator) {
                value += ', ' + ui.item.desc;
            }
            $(this)
                .val(value)
                .closest('.input-group').find('.input-group-addon')
                .empty()
                .html('<span class="i ' + ui.item.icon + ' fa-fw"></span>');

            if (ui.item.value.geoLocator) {
                ulm_geoLocator();
            } else {
                let located = ui.item.label + ', ' + ui.item.desc;
                let loctype = 'default';
                if (ui.item.icon === 'fas fa-search-location') {
                    located = ui.item.desc;
                    loctype = 'given';
                }
                $(this).data({
                    lat: ui.item.value.lat,
                    lon: ui.item.value.lon,
                    located: located,
                    loctype: loctype
                });
                ulm_loadStep1();
            }
            return false;
        },
        close: function(e, ui) {
            $(e.target).blur();
        }
    }).focus(function() {
        $(this).val('').autocomplete('search', '');
        document.getElementById("ulm").scrollIntoView();
    }).autocomplete("instance")._renderItem = function(ul, item) {
        let desc = "";
        if (item.desc && item.desc != "") {
            desc = ', <span class="desc">' + item.desc + '</span>';
        }
        return $("<li>")
            .append('<div class="ac-left"><span class="i ' + item.icon + ' fa-fw"></span></div><div class="ac-right"><span class="label">' + item.label + '</span>' + desc + '</div>')
            .appendTo(ul);
    };

};

/* START metaVonBisMode Functions */

const ulm_dateString2dateObject = function(dateString) { // yyyy-mm-dd

    let dateObj = dateString.split("-");
    dateObj = new Date(dateObj[0], parseInt(dateObj[1]) - 1, parseInt(dateObj[2]));
    return dateObj;

};

const ulm_bisDateMin = function(vonDate) {

    const nextDay = vonDate;
    nextDay.setDate(nextDay.getDate() + 0);
    let nDd = (nextDay.getDate() < 10) ? '0' + nextDay.getDate() : nextDay.getDate();
    const nDaymFix = nextDay.getMonth() + 1;
    let nDm = (nDaymFix < 10) ? '0' + nDaymFix : nDaymFix;
    $ulm.find('.form-control[name="dateBis"]').prop({
        'min': nextDay.getFullYear() + '-' + nDm + '-' + nDd
    });

};

const ulm_bisDateClearIf2Early = function(vonDate) {

    const $bisDate = $ulm.find('.form-control[name="dateBis"]');
    const actBisDate = ulm_dateString2dateObject($bisDate.val());
    if (actBisDate < vonDate) {
        $bisDate.val('');
    }

};

/*
const ulm_checkLiveView = function($step2) {
    const liveViewDistance = parseInt($ulm.data('liveviewumkreis'));
    let getParamWorkaround = (window.location.search.indexOf('AR=1') > -1) ? true : false;

    if ($('#ulm.enableLiveView').length && getParamWorkaround) {
        let liveView = false;

        $.each($step2.find('.entry'), function() {
            const $entry = $(this);
            const distance = parseInt($entry.find('a').prop('href').split('#distance=')[1]);
            if (distance <= liveViewDistance) {
                liveView = true;
                $entry.addClass('liveView');
                $entry.append('<a href="#" class="ulm_liveViewTrigger_entry"><span class="i fas fa-eye"></span></a>');
            }
        });

        if (liveView) {
            let $listLiveViewTrigger = $('<form />').prop({
                'action': '/ulm-live-view.html?no_cache=1', // wenn LIVE relativen PFAD verwenden
                'method': 'post',
                'target': '_blank'
            }).addClass('ulm_liveViewTrigger').html('<span class="i fas fa-eye"></span>');
            if ($('#ulmMaps').length > 0) {
                $listLiveViewTrigger.addClass('ulm_liveViewTrigger--map');
            }
            $listLiveViewTrigger.clone().insertAfter($step2);

            if ($('#ulm .ulm_liveView').length === 0) {
                let $container = $('<div />').addClass('container').append($listLiveViewTrigger.clone().append('<span class="label">Live View (' + liveViewDistance + ' m)</span>')),
                    $section_liveView = $('<section />').addClass('ulm_liveView').append($container);
                $section_liveView.insertBefore($('#ulm .ajax-step1'));
            }

        }
    }
};
*/
